import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Route } from "react-router-dom";
import { useAuth } from "../../context/auth-context";
import ErrorFallback from './../errorHandling/error-fallback-page';
import { handleBoundaryError } from '../../utils/globalErrorHandler';
import { useAuthCheck } from "../../context/auth-check-context";
import RouteLoadingSpinner from "../loading/RouteLoadingSpinner";
import LoginRedirect from "./LoginRedirect";

/**
 * AdminRoute - Route wrapper that requires authentication and admin privileges.
 * Shows a loading spinner while the auth check is in progress.
 * Redirects to `/login` when the user is unauthenticated or lacks admin access.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.component - The component to render for authorized admins.
 * @returns {JSX.Element}
 */
export default function AdminRoute({ component: Component, ...rest }) {
  const { currentUser } = useAuth();
  const { isAdmin, loading } = useAuthCheck();

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleBoundaryError}>
      <Route
        {...rest}
        render={(props) => {
          if (loading) return <RouteLoadingSpinner />;
          return currentUser && isAdmin ? (
            <Component {...props} />
          ) : (
            <LoginRedirect />
          );
        }}
      />
    </ErrorBoundary>
  );
}
